import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Pimprichichwadtobhimashankarcab() {



    const cardData = {

keyword: "Pimpri Chinchwad to Bhimashankar Cab",

headingDescription:
    "Rising Cab Service offers dependable Pimpri Chinchwad to Bhimashankar Cab services for pilgrims, families, and travelers seeking a comfortable trip to the sacred Bhimashankar Jyotirlinga. We provide one-way and round-trip taxi options with clean Sedan, SUV, Innova Crysta, and Tempo Traveller vehicles driven by experienced chauffeurs. With affordable fares, timely pickups, and 24/7 availability, our cab service ensures a safe and hassle-free journey for temple visits, sightseeing, and weekend getaways.",

topPlaces: [
    {
        title: "Bhimashankar Jyotirlinga Temple",
        description:
            "Bhimashankar Jyotirlinga Temple is one of the twelve revered Jyotirlingas of Lord Shiva and a major pilgrimage destination in Maharashtra. Surrounded by the scenic Sahyadri hills, the ancient temple is admired for its spiritual atmosphere, beautiful stone architecture, and religious significance. Thousands of devotees visit throughout the year to seek blessings and participate in special festivals."
    },
    {
        title: "Bhimashankar Wildlife Sanctuary",
        description:
            "Bhimashankar Wildlife Sanctuary is a protected forest area rich in biodiversity and natural beauty. It is famous for the Indian Giant Squirrel, numerous bird species, and dense evergreen forests. Visitors can enjoy peaceful nature walks, trekking trails, and the refreshing environment of the Western Ghats."
    },
    {
        title: "Gupt Bhimashankar",
        description:
            "Gupt Bhimashankar is a sacred location where the Bhima River is believed to emerge mysteriously through the forest. The site is surrounded by natural beauty and offers a calm atmosphere for devotees and nature enthusiasts looking to experience the spiritual side of the region."
    },
    {
        title: "Hanuman Lake",
        description:
            "Hanuman Lake is a picturesque water body situated near the temple complex and is known for its peaceful surroundings. The lake is an excellent spot for relaxation and photography, allowing visitors to enjoy the tranquil beauty of the Bhimashankar hills."
    },
    {
        title: "Nagphani Point",
        description:
            "Nagphani Point, popularly known as Cobra's Hood, is one of the highest viewpoints near Bhimashankar. The location offers spectacular views of the valleys, forests, and mountain ranges, making it a favorite destination for trekkers and adventure lovers."
    },
    {
        title: "Sakshi Vinayak Temple",
        description:
            "Sakshi Vinayak Temple is an important shrine dedicated to Lord Ganesha near Bhimashankar Temple. According to local beliefs, devotees should visit this temple as part of their pilgrimage, making it a significant spiritual stop during the journey."
    },
    {
        title: "Moksha Kund",
        description:
            "Moksha Kund is a sacred water tank associated with ancient legends and religious rituals. Pilgrims visit the site for meditation and prayers, believing that it holds spiritual importance and brings peace and blessings."
    },
    {
        title: "Ahupe Ghat",
        description:
            "Ahupe Ghat is a beautiful mountain pass known for its breathtaking landscapes, lush greenery, and dramatic cliffs. During the monsoon season, waterfalls and mist-covered hills create a stunning natural setting for sightseeing and photography."
    },
    {
        title: "Kondhwal Waterfall",
        description:
            "Kondhwal Waterfall is a hidden gem near Bhimashankar that comes alive during the rainy season. Surrounded by forests and rocky terrain, the waterfall provides a refreshing escape for visitors looking to enjoy nature and scenic beauty."
    },
    {
        title: "Bhorgiri Fort",
        description:
            "Bhorgiri Fort is an ancient hill fort located close to Bhimashankar and is popular among trekking enthusiasts. The fort offers panoramic views of the surrounding valleys and forests, while the nearby caves and temples add historical and cultural significance to the visit."
    }
],



services: [
  {
    name: "Pimpri Chinchwad to Bhimashankar Cab",
    description: "Rising Cab Service offers reliable Pimpri Chinchwad to Bhimashankar Cab for safe, comfortable, and affordable pilgrimage travel to the sacred Bhimashankar Jyotirlinga. Enjoy doorstep pickup from any PCMC location, clean AC vehicles, experienced drivers familiar with ghat roads, and smooth highway travel designed for families, groups, and solo devotees."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar Taxi Service",
    description: "Book Pimpri Chinchwad to Bhimashankar Taxi Service with Rising Cab Service for a stress-free and devotional journey. We provide well-maintained cars, professional chauffeurs, transparent pricing, and 24x7 availability, ensuring a safe and peaceful ride to the temple with complete comfort."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar Cab Booking",
    description: "Easy Pimpri Chinchwad to Bhimashankar Cab Booking system for instant reservations with multiple vehicle options including Sedan, SUV, Innova Crysta, and Tempo Traveller. Get quick confirmation, flexible pickup timing, and reliable customer support for a smooth travel experience."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar One Way Cab",
    description: "Affordable Pimpri Chinchwad to Bhimashankar One Way Cab service for drop-only travel without return charges. Ideal for budget travelers and devotees, offering transparent pricing, AC vehicles, and professional drivers for safe long-distance travel."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar Round Trip Cab",
    description: "Book Pimpri Chinchwad to Bhimashankar Round Trip Cab for same-day or flexible return journeys. Includes waiting time at the temple, comfortable AC rides, experienced drivers, and cost-effective packages for families and groups."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar Jyotirlinga Cab",
    description: "Special Pimpri Chinchwad to Bhimashankar Jyotirlinga Cab service designed for devotees visiting the sacred Jyotirlinga temple. Enjoy smooth travel through scenic ghat routes with safe driving, timely pickup, and spiritual comfort."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar Darshan Cab",
    description: "Dedicated Pimpri Chinchwad to Bhimashankar Darshan Cab service for hassle-free temple visits. Includes door-to-door pickup, temple waiting time, and return travel options ensuring a peaceful and well-organized pilgrimage experience."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar Taxi Fare",
    description: "Get transparent Pimpri Chinchwad to Bhimashankar Taxi Fare with affordable pricing based on vehicle type and travel plan. We ensure no hidden charges, budget-friendly packages, and complete value for money for your pilgrimage journey."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar Innova Crysta Cab",
    description: "Premium Pimpri Chinchwad to Bhimashankar Innova Crysta Cab service for families and groups seeking extra comfort, space, and luxury. Enjoy spacious seating, smooth ride quality, and professional drivers for a safe and relaxing journey."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar AC Cab Service",
    description: "Comfortable Pimpri Chinchwad to Bhimashankar AC Cab Service offering clean, air-conditioned vehicles for a pleasant travel experience. Ideal for long-distance pilgrimage trips with safety, comfort, and affordability."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar Outstation Cab",
    description: "Reliable Pimpri Chinchwad to Bhimashankar Outstation Cab service for safe intercity travel with experienced drivers, flexible booking options, and well-maintained vehicles suitable for all types of travelers."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar Tour Package",
    description: "Complete Pimpri Chinchwad to Bhimashankar Tour Package including pickup, temple visit, waiting time, and return journey. Perfect for families and groups looking for a well-planned pilgrimage experience."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar Tempo Traveller",
    description: "Book Pimpri Chinchwad to Bhimashankar Tempo Traveller for large groups and family pilgrimages. Spacious seating, luggage space, and experienced drivers ensure a comfortable and safe group journey."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar Family Cab",
    description: "Comfortable Pimpri Chinchwad to Bhimashankar Family Cab service designed for family trips with safe drivers, clean vehicles, and smooth travel experience for a peaceful pilgrimage."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar Private Taxi",
    description: "Book Pimpri Chinchwad to Bhimashankar Private Taxi for personalized travel with full vehicle privacy, flexible timing, and professional drivers ensuring a safe and comfortable journey."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar Online Cab Booking",
    description: "Easy Pimpri Chinchwad to Bhimashankar Online Cab Booking system for instant reservations, fare transparency, and quick confirmation with multiple vehicle choices available."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar Same Day Return Cab",
    description: "Pimpri Chinchwad to Bhimashankar Same Day Return Cab service designed for quick pilgrimage trips with early pickup, temple darshan, waiting time, and same-day return to PCMC."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar SUV Cab Service",
    description: "Reliable Pimpri Chinchwad to Bhimashankar SUV Cab Service for group travel with spacious seating, strong performance on ghat roads, and comfortable long-distance journey experience."
  },
  {
    name: "Bhimashankar Cab from Pimpri Chinchwad",
    description: "Book Bhimashankar Cab from Pimpri Chinchwad for direct, safe, and comfortable travel to the Jyotirlinga temple with professional drivers and flexible booking options."
  },
  {
    name: "PCMC to Bhimashankar Cab Booking",
    description: "Quick PCMC to Bhimashankar Cab Booking service offering instant confirmation, affordable pricing, and multiple vehicle options for smooth pilgrimage travel."
  }
],

tableData: [
  ["Pimpri Chinchwad to Bhimashankar Cab", "Pimpri Chinchwad to Bhimashankar Taxi Service"],
  ["Pimpri Chinchwad to Bhimashankar Cab Booking", "Pimpri Chinchwad to Bhimashankar One Way Cab"],
  ["Pimpri Chinchwad to Bhimashankar Round Trip Cab", "Pimpri Chinchwad to Bhimashankar Jyotirlinga Cab"],
  ["Pimpri Chinchwad to Bhimashankar Darshan Cab", "Pimpri Chinchwad to Bhimashankar Taxi Fare"],
  ["Pimpri Chinchwad to Bhimashankar Innova Crysta Cab", "Pimpri Chinchwad to Bhimashankar AC Cab Service"],
  ["Pimpri Chinchwad to Bhimashankar Outstation Cab", "Pimpri Chinchwad to Bhimashankar Tour Package"],
  ["Pimpri Chinchwad to Bhimashankar Tempo Traveller", "Pimpri Chinchwad to Bhimashankar Family Cab"],
  ["Pimpri Chinchwad to Bhimashankar Private Taxi", "Pimpri Chinchwad to Bhimashankar Online Cab Booking"],
  ["Pimpri Chinchwad to Bhimashankar Same Day Return Cab", "Pimpri Chinchwad to Bhimashankar SUV Cab Service"],
  ["Bhimashankar Cab from Pimpri Chinchwad", "PCMC to Bhimashankar Cab Booking"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Pimpri Chinchwad to Bhimashankar Cab Service",
        WhyChoosedescription: "Rising Cab Service offers dependable cab services from Pimpri Chinchwad to Bhimashankar for devotees, families, tourists, and groups seeking a comfortable pilgrimage journey."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Long-Distance Travel",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, SUVs, and spacious vehicles that provide a comfortable travel experience throughout the journey."
    },
    {
        WhyChooseheading: "Professional Drivers with Route Expertise",
        WhyChoosedescription: "Our experienced drivers are familiar with the Pimpri Chinchwad to Bhimashankar route, ensuring safe driving and a smooth travel experience."
    },
    {
        WhyChooseheading: "Affordable Bhimashankar Cab Packages",
        WhyChoosedescription: "Rising Cab Service provides cost-effective cab packages with transparent pricing, making pilgrimage travel convenient and budget-friendly."
    },
    {
        WhyChooseheading: "One Way and Round Trip Facilities",
        WhyChoosedescription: "Customers can choose one-way transfers, same-day return journeys, or customized round-trip packages according to their travel requirements."
    },
    {
        WhyChooseheading: "Convenient Pickup Across PCMC Areas",
        WhyChoosedescription: "We offer pickup services from Pimpri, Chinchwad, Nigdi, Akurdi, Ravet, Wakad, Pimple Saudagar, Bhosari, Moshi, and all major PCMC locations."
    },
    {
        WhyChooseheading: "Ideal for Bhimashankar Jyotirlinga Darshan",
        WhyChoosedescription: "Our cab service is specially designed for devotees visiting Bhimashankar Jyotirlinga, ensuring a peaceful and comfortable spiritual journey."
    },
    {
        WhyChooseheading: "24/7 Booking and Customer Support",
        WhyChoosedescription: "Rising Cab Service provides round-the-clock booking assistance and customer support for all Pimpri Chinchwad to Bhimashankar travel requirements."
    }
]
};

const faqData = [
    {
        question: "Do you provide cab service from Pimpri Chinchwad to Bhimashankar?",
        answer: "Yes, Rising Cab Service offers dedicated cab services from Pimpri Chinchwad to Bhimashankar for individuals, families, and groups."
    },
    {
        question: "How far is Bhimashankar from Pimpri Chinchwad?",
        answer: "Bhimashankar is approximately 115 to 130 kilometers from Pimpri Chinchwad depending on the pickup point and route selected."
    },
    {
        question: "Can I book a one-way cab to Bhimashankar?",
        answer: "Yes, we provide both one-way and round-trip cab services from Pimpri Chinchwad to Bhimashankar."
    },
    {
        question: "Which vehicle options are available?",
        answer: "We offer Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and larger vehicles for group travel."
    },
    {
        question: "Do you provide same-day return packages?",
        answer: "Yes, customers can book same-day return cab packages for Bhimashankar Darshan."
    },
    {
        question: "Are your drivers experienced on this route?",
        answer: "Yes, our drivers regularly travel on the Bhimashankar route and are familiar with all major roads and travel conditions."
    },
    {
        question: "Can senior citizens travel comfortably?",
        answer: "Yes, our vehicles are well-maintained and suitable for senior citizens, families, and pilgrims."
    },
    {
        question: "Do you provide pickup from all PCMC areas?",
        answer: "Yes, pickup services are available from Pimpri, Chinchwad, Nigdi, Wakad, Ravet, Bhosari, Moshi, Akurdi, and nearby locations."
    },
    {
        question: "Can I include sightseeing during the trip?",
        answer: "Yes, customized travel plans can include nearby attractions and sightseeing spots around Bhimashankar."
    },
    {
        question: "How can I book a Pimpri Chinchwad to Bhimashankar Cab?",
        answer: "You can book your cab through phone, WhatsApp, or online booking with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nitin Patil",
        feedback:
            "The Bhimashankar trip from Pimpri was very comfortable. The driver arrived on time, the vehicle was clean, and the entire journey was smooth and pleasant.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Kavita Joshi",
        feedback:
            "Our family visited Bhimashankar Jyotirlinga with Rising Cab Service and had an excellent experience. Professional service, safe driving, and great customer support throughout the journey.",
        rating: 5
    }
];






















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];






const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pimpri Chinchwad to Bhimashankar Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pimpri-chinchwad-to-bhimashankar-cab.jpg",
"description": "Book Pimpri Chinchwad to Bhimashankar Cab Service with Rising Cab Service for comfortable temple visits and outstation travel. Enjoy affordable fares, professional drivers, AC cabs, one-way and round-trip taxi services to Bhimashankar Jyotirlinga.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pimpri-chinchwad-to-bhimashankar-cab"
}
};

<Helmet>
  <title>Pimpri Chinchwad to Bhimashankar Cab Service | Taxi Booking | +91 9272511548</title>

<meta
 name="description"
 content="Book Pimpri Chinchwad to Bhimashankar Cab Service at affordable rates. AC taxi service for Bhimashankar Jyotirlinga darshan with one-way, round-trip, and outstation cab options."
/>

<meta
 name="keywords"
 content="Pimpri Chinchwad to Bhimashankar Cab, Pimpri Chinchwad to Bhimashankar Taxi Service, Pimpri Chinchwad to Bhimashankar Cab Booking, Pimpri Chinchwad to Bhimashankar One Way Cab, Pimpri Chinchwad to Bhimashankar Round Trip Cab, Pimpri Chinchwad to Bhimashankar Jyotirlinga Cab, Pimpri Chinchwad to Bhimashankar Darshan Cab, Pimpri Chinchwad to Bhimashankar Taxi Fare, Pimpri Chinchwad to Bhimashankar Innova Crysta Cab, Pimpri Chinchwad to Bhimashankar AC Cab Service, Pimpri Chinchwad to Bhimashankar Outstation Cab, Bhimashankar temple taxi from Pimpri Chinchwad, Pimpri to Bhimashankar cab service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>











    return (
        <div>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/3.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Pimprichichwadtobhimashankarcab;